import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LangProvider } from "@/i18n/LangContext";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import OfferDetail from "@/pages/OfferDetail";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import Contact from "@/pages/Contact";
import FaqPage from "@/pages/FaqPage";
import Legal from "@/pages/Legal";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <Routes>
          <Route element={<Layout />}>
            {/* Français (canonique) */}
            <Route path="/" element={<Home />} />
            <Route path="/qui-suis-je" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<OfferDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Article />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/politique-de-confidentialite" element={<Privacy />} />
            {/* English */}
            <Route path="/en" element={<Home />} />
            <Route path="/en/about" element={<About />} />
            <Route path="/en/services" element={<Services />} />
            <Route path="/en/services/:slug" element={<OfferDetail />} />
            <Route path="/en/blog" element={<Blog />} />
            <Route path="/en/blog/:slug" element={<Article />} />
            <Route path="/en/contact" element={<Contact />} />
            <Route path="/en/faq" element={<FaqPage />} />
            <Route path="/en/legal-notice" element={<Legal />} />
            <Route path="/en/privacy-policy" element={<Privacy />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </LangProvider>
    </BrowserRouter>
  );
}

export default App;
